import { Component, Input } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';
import { CurrencyMaskConfig } from '@ngodings/ngx-currency';

@Component({
  selector: 'app-money-input',
  templateUrl: './money-input.component.html',
  styleUrls: ['./money-input.component.scss'],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
})
export class MoneyInputComponent {
  @Input()
  appearance?: 'fill' | 'outline' = 'outline';

  @Input()
  label: string = '';

  @Input()
  name: string = '';

  @Input()
  icon?: string = '';

  @Input()
  moneyOptions?: Partial<CurrencyMaskConfig>;

  constructor() { }

}
